var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "form-group mb-3" }, [
      _c("div", [
        _vm._v(
          _vm._s(_vm.$t("testEquipment.measurementSpecification.model.name"))
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.specification.name,
              expression: "specification.name"
            }
          ],
          staticClass: "form-control",
          domProps: { value: _vm.specification.name },
          on: {
            input: function($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.specification, "name", $event.target.value)
            }
          }
        })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group mb-3" }, [
      _c("div", [
        _vm._v(
          _vm._s(
            _vm.$t("testEquipment.measurementSpecification.model.description")
          )
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.specification.description,
              expression: "specification.description"
            }
          ],
          staticClass: "form-control",
          domProps: { value: _vm.specification.description },
          on: {
            input: function($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.specification, "description", $event.target.value)
            }
          }
        })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group mb-3" }, [
      _c("div", [
        _vm._v(
          _vm._s(_vm.$t("testEquipment.measurementSpecification.model.type"))
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.specification.type,
                expression: "specification.type"
              }
            ],
            staticClass: "form-control",
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.$set(
                  _vm.specification,
                  "type",
                  $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                )
              }
            }
          },
          _vm._l(_vm.getEnumValues(_vm.MeasurementValueType), function(entry) {
            return _c(
              "option",
              { key: entry.value, domProps: { value: entry.value } },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t(
                        "testEquipment.measurementValueType." +
                          _vm.camelCase(entry.name)
                      )
                    ) +
                    "\n        "
                )
              ]
            )
          }),
          0
        )
      ])
    ]),
    _vm._v(" "),
    _vm.isFloat
      ? _c("div", { staticClass: "form-group mb-3" }, [
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "testEquipment.measurementSpecification.model.lowerBound"
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm.isFloat
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.specification.lowerBound,
                      expression: "specification.lowerBound"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "number", step: "0.1" },
                  domProps: { value: _vm.specification.lowerBound },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.specification,
                        "lowerBound",
                        $event.target.value
                      )
                    }
                  }
                })
              : _vm.isString
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.specification.lowerBound,
                      expression: "specification.lowerBound"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", maxlength: "32" },
                  domProps: { value: _vm.specification.lowerBound },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.specification,
                        "lowerBound",
                        $event.target.value
                      )
                    }
                  }
                })
              : _vm._e()
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "form-group mb-3" }, [
      _c("div", [
        _vm._v(
          _vm._s(
            _vm.$t("testEquipment.measurementSpecification.model.nominalValue")
          )
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _vm.isFloat
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.specification.nominalValue,
                  expression: "specification.nominalValue"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "number", step: "0.1" },
              domProps: { value: _vm.specification.nominalValue },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.specification,
                    "nominalValue",
                    $event.target.value
                  )
                }
              }
            })
          : _vm.isString
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.specification.nominalValue,
                  expression: "specification.nominalValue"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", maxlength: "32" },
              domProps: { value: _vm.specification.nominalValue },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.specification,
                    "nominalValue",
                    $event.target.value
                  )
                }
              }
            })
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _vm.isFloat
      ? _c("div", { staticClass: "form-group mb-3" }, [
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "testEquipment.measurementSpecification.model.upperBound"
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm.isFloat
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.specification.upperBound,
                      expression: "specification.upperBound"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "number", step: "0.1" },
                  domProps: { value: _vm.specification.upperBound },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.specification,
                        "upperBound",
                        $event.target.value
                      )
                    }
                  }
                })
              : _vm.isString
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.specification.upperBound,
                      expression: "specification.upperBound"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", maxlength: "32" },
                  domProps: { value: _vm.specification.upperBound },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.specification,
                        "upperBound",
                        $event.target.value
                      )
                    }
                  }
                })
              : _vm._e()
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "form-group mb-0" }, [
      _c("div", { staticClass: "form-check" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.specificationRequired,
              expression: "specificationRequired"
            }
          ],
          staticClass: "form-check-input",
          attrs: { type: "checkbox", id: _vm.uid + "required" },
          domProps: {
            checked: Array.isArray(_vm.specificationRequired)
              ? _vm._i(_vm.specificationRequired, null) > -1
              : _vm.specificationRequired
          },
          on: {
            change: function($event) {
              var $$a = _vm.specificationRequired,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.specificationRequired = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.specificationRequired = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.specificationRequired = $$c
              }
            }
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-check-label",
            attrs: { for: _vm.uid + "required" }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$t(
                    "testEquipment.measurementSpecification.model.required"
                  )
                ) +
                "\n      "
            )
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("div", { staticClass: "form-check" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.specification.allowSeparateTester,
              expression: "specification.allowSeparateTester"
            }
          ],
          staticClass: "form-check-input",
          attrs: { type: "checkbox", id: _vm.uid + "allowSeparateTester" },
          domProps: {
            checked: Array.isArray(_vm.specification.allowSeparateTester)
              ? _vm._i(_vm.specification.allowSeparateTester, null) > -1
              : _vm.specification.allowSeparateTester
          },
          on: {
            change: function($event) {
              var $$a = _vm.specification.allowSeparateTester,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 &&
                    _vm.$set(
                      _vm.specification,
                      "allowSeparateTester",
                      $$a.concat([$$v])
                    )
                } else {
                  $$i > -1 &&
                    _vm.$set(
                      _vm.specification,
                      "allowSeparateTester",
                      $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                    )
                }
              } else {
                _vm.$set(_vm.specification, "allowSeparateTester", $$c)
              }
            }
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-check-label",
            attrs: { for: _vm.uid + "allowSeparateTester" }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$t(
                    "testEquipment.measurementSpecification.model.allowSeparateTester"
                  )
                ) +
                "\n      "
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }